import { lazy } from "react";
import { Navigate, Route } from "react-router-dom";

const MainLayout = lazy(() => import("src/_modules/layouts/MainLayout"));
const ErrorUnauthorized = lazy(() => import("src/_modules/Error/ErrorUnauthorized"));
const ErrorNotFound = lazy(() => import("src/_modules/Error/ErrorNotFound"));
const ErrorServerDown = lazy(() => import("src/_modules/Error/ErrorServerDown"));
const ErrorNetwork = lazy(() => import("src/_modules/Error/ErrorNetwork"));

const errorRoutes = () => (
    <>
        <Route path="errors" element={<MainLayout />}>
            <Route path="401" element={<ErrorUnauthorized />} />
            <Route path="404" element={<ErrorNotFound />} />
            <Route path="500" element={<ErrorServerDown />} />
            <Route path="network" element={<ErrorNetwork />} />
            <Route path="" element={<Navigate to="404" />} />
            <Route path="*" element={<Navigate to="404" />} />
        </Route>
    </>
)

export default errorRoutes;
